import { cn } from '@/app/utils/cn'

interface StepsProgressProps {
  currentStep: number
  totalSteps: number
}

export function StepsProgress({ currentStep, totalSteps }: StepsProgressProps) {
  return (
    <div className="mb-8">
      <div className="mb-4 flex gap-2">
        {Array.from({ length: totalSteps }, (_, index) => (
          <div
            key={index}
            className={cn(
              'h-5 flex-1 rounded-full transition-all duration-300',
              index <= currentStep ? 'bg-primary' : 'bg-gray-200',
            )}
          />
        ))}
      </div>
    </div>
  )
}
